import { render, staticRenderFns } from "./PersonList.vue?vue&type=template&id=ce9c1852"
import script from "./PersonList.vue?vue&type=script&lang=ts"
export * from "./PersonList.vue?vue&type=script&lang=ts"
import style0 from "./PersonList.vue?vue&type=style&index=0&id=ce9c1852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports